import { PrimitiveValueObject } from '@/domain/primitiveValueObject';

/**
 * 子ID
 */
export class ChildId extends PrimitiveValueObject<string> {
  /**
   * 生成
   * @param value 値
   * @returns 生成値
   */
  static create(value: string): ChildId {
    return new ChildId(value);
  }
}
